import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedSiteBottom = selectedLocale => {
  const {
    allPrismicSiteBottom: { edges: siteBottoms },
  } = useStaticQuery(graphql`
    query {
      allPrismicSiteBottom {
        edges {
          node {
            lang
            data {
              sitemap_title
              sitemap {
                title
                link {
                  url
                  link_type
                  target
                }
              }
              contacts_title
              contacts {
                title
                link {
                  url
                  link_type
                }
              }
              social_links {
                title
                href {
                  url
                }
                icon {
                  alt
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 25, maxHeight: 25) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                    url
                    extension
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return siteBottoms.filter(({ node }) => node.lang === selectedLocale);
};
